import { render, staticRenderFns } from "./TemplateCategoryCreate.vue?vue&type=template&id=c2c662a2"
import script from "./TemplateCategoryCreate.vue?vue&type=script&lang=js"
export * from "./TemplateCategoryCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports